import type { LoginParams, LoginResponse , RegisterParams, RegisterResponse } from "@hz/stealthy-gmc-cloaker-common/api-types/auth";
import type {
  AddStoresResponse,
  GetStoresResponse,
  NewStoreFormValuesType,
} from "@hz/stealthy-gmc-cloaker-common/api-types/store";

import { api, Tags } from "@state/apiSlice";

const storesRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getStores: build.query<GetStoresResponse, {}>({
      query: () => ({
        url: "/stores",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: [Tags.Stores],
    }),
    addStore: build.mutation<AddStoresResponse, NewStoreFormValuesType[]>({
      query: (data) => ({
        url: "/stores",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          stores: data,
        },
        method: "POST",
      }),
      invalidatesTags: [Tags.Stores],
    }),
    editStore: build.mutation<{ success: boolean }, { storeId: string; isDisabled: boolean }>({
      query: ({ storeId, isDisabled }) => ({
        url: `/stores/${storeId}`,
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          disabled: isDisabled,
        },
      }),
      invalidatesTags: [Tags.Stores],
    }),
  }),
});

export default storesRequestsSlice;
